module.exports = __webpack_public_path__ + "assets/devices/SD-304-PG2-2fd342291fa0adfb29e22fa2aa4516ec.svg";